import { memo } from 'react';
import cn from 'classnames';
import dayjs from 'dayjs';
import { unixToDate } from 'src/utils/date';
import { Element } from 'src/components';

import { IMatch } from '@zmedia/bm-soccer-ui/interface';
import { MATCH_STATUS } from '@zmedia/bm-soccer-ui/constants';
import { TimeUtils } from 'src/utils';

interface IMatchTop extends IMatch {
    start_time?: number;
}

const MatchItem = ({
    start_time: startTime = 0,
    has_pen_shootout: hasPenShootout = false,
    status,
    away,
    home,
}: IMatchTop) => {
    const isLive = status.id == MATCH_STATUS.LIVE;
    const isNotStart = status.id == MATCH_STATUS.NOT_STARTED;
    const _isToday = dayjs(startTime * 1000).isToday();
    const isSameYear =
        unixToDate(startTime, 'YYYY') ===
        unixToDate(TimeUtils.currentSecords(), 'YYYY');

    let date = unixToDate(startTime, 'DD/MM/YYYY');
    if (isSameYear) {
        date = unixToDate(startTime, 'dddd, DD/MM');
    }

    if (_isToday) {
        date = unixToDate(startTime, '[Hôm nay]');
    }

    return (
        <Element className={cn('match', 'relative', 'mr-[1px]', 'p-[10px]')}>
            <Element className={cn('match__header')}>
                <Element className={'text-[#595959] font-semibold flex'}>
                    {unixToDate(startTime, 'HH:mm')}
                    {isLive ? (
                        <Element className="flex items-center">
                            <Element
                                renderAs="span"
                                className={cn(
                                    'bullet',
                                    'relative top-[-1px] inline-block',
                                    'w-[5px] h-[5px] rounded-full bg-[#db2331]',
                                    'after:absolute after:w-full after:h-full after:rounded-full after:top-0 after:left-0',
                                    'after:animate-[pulse_2s_ease-out_infinite]',
                                    'after:[animation-delay:1s]',
                                    'after:',
                                    'after:opacity-0',
                                    'after:scale-100',
                                    'after:bg-[#db2331]',
                                    'before:absolute before:w-full before:h-full before:rounded-full before:top-0 before:left-0',
                                    'before:animate-[pulse_2s_ease-out_infinite]',
                                    'before:opacity-0',
                                    'before:scale-100',
                                    'before:bg-[#db2331]',
                                    'ml-[10px] mr-[8px]',
                                )}
                            ></Element>
                            <Element renderAs="span" className="text-[red]">
                                Trực tiếp
                            </Element>
                        </Element>
                    ) : (
                        <Element className="flex items-center ml-[6px]">
                            <Element renderAs="span">
                                {status.live_label}
                            </Element>
                        </Element>
                    )}
                </Element>
                <Element className={'text-[#848485] italic capitalize'}>
                    {date}
                </Element>
            </Element>
            <Element className={cn('relative', 'text-[#000] font-bold')}>
                <Element
                    className={cn('flex items-start', 'w-full', 'mt-[8px]')}
                >
                    <Element
                        renderAs="img"
                        className="w-[20px] h-[20px] mr-[8px] shrink-0"
                        src={home.team.logo}
                    />
                    <Element className="truncate">{home.team.name}</Element>
                    {!isNotStart && (
                        <>
                            <Element className="ml-auto">{home.score}</Element>
                            <>
                                {hasPenShootout && (
                                    <Element className="text-[#8A8A8A] text-[10px] ml-[2px]">
                                        ({home.score_pen})
                                    </Element>
                                )}
                            </>
                        </>
                    )}
                </Element>
                <Element
                    className={cn('flex items-start', 'w-full', 'mt-[8px]')}
                >
                    <Element
                        className="w-[20px] h-[20px] mr-[8px] shrink-0"
                        src={away.team.logo}
                        renderAs="img"
                    />
                    <Element className="truncate">{away.team.name}</Element>
                    {!isNotStart && (
                        <>
                            <Element className="ml-auto">{away.score}</Element>
                            <>
                                {hasPenShootout && (
                                    <Element className="text-[#8A8A8A] text-[10px] ml-[2px]">
                                        ({away.score_pen})
                                    </Element>
                                )}
                            </>
                        </>
                    )}
                </Element>
            </Element>
        </Element>
    );
};

export default memo(MatchItem);
